import useMerkleLeaves from '../../read/swap/useMerkleLeaves';
import { useNftx, useTransaction, UseTransactionOptions } from '@nftx/react';
import { Vault } from 'nftx.js';

const useProcessTokens = (
  { vault }: { vault: Vault },
  opts?: UseTransactionOptions
) => {
  const {
    provider,
    signer,
    core: { processTokens },
  } = useNftx();
  const { data: leaves } = useMerkleLeaves({ vault });

  return useTransaction(
    ({ tokenIds }: { tokenIds: `${number}`[] }) => {
      return processTokens({
        signer,
        provider,
        leaves,
        vault,
        tokenIds,
      });
    },
    {
      description: 'Process Tokens',
      ...opts,
    }
  );
};

export default useProcessTokens;
